module.exports = __webpack_public_path__ + "media/IMO-Tagesabrechnung_Schulung_v2.aa6f6c11.mp4";